import { createContext, FC, ReactNode, useCallback, useContext, useMemo, useState } from 'react';

interface IModalContextProviderProps {
  children: ReactNode;
}

interface ModalContextData {
  addModal: (modal: ReactNode) => () => void;
}

const ModalContext = createContext<ModalContextData>({
  addModal: () => () => {},
});

export const ModalContextProvider: FC<IModalContextProviderProps> = ({ children }) => {
  const [modals, setModals] = useState<ReactNode[]>([]);

  const addModal = useCallback((modal: ReactNode) => {
    setModals((_oldModals) => [..._oldModals, modal]);

    const removeModalFilter = (_oldModals: ReactNode[]) =>
      _oldModals.filter((item) => item !== modal);

    return () => {
      setModals(removeModalFilter);
    };
  }, []);

  const value = useMemo(
    () => ({
      addModal,
    }),
    [addModal],
  );

  return (
    <ModalContext.Provider value={value}>
      {children}
      {modals}
    </ModalContext.Provider>
  );
};

export const useModal = () => useContext(ModalContext);
